<template lang="pug">
page-layout#job(
	:heading='heading'
	:num-of-slide-outs='1'
	:class='{ "above-side-nav" : jobPageState === "opened" }'
)
	.link-container(slot='link-container')
		//- a.alter(href='#') Alter Entry Settings
		// ? getting rid of the map reference since link leads no where.
		//- router-link.map(to='/app/map') View on Map
		button-expand(
			title='Create a New Job'
			:options='options'
		)
	job-slide-out(
		slot='slideout-1'
		:state='jobPageState'
		:asset='activeJob'
		:asset-key='jobKey'
		asset-name='jobs'
		@close='jobPageState = "closed"; activeJob = null;'
		@edit='editJob'
		@delete='deleteJob'
	)
	asset-table(
		slot='content'
		asset-name='jobs'
		asset-key='jobsKey'
		search-text='Search for a Job'
		:config='config'
		:get-all='GetJobs'
		:get='GetJob'
		:search='SearchJobs'
		:download-csv='DownloadJobsCSV'
		:download-pdf='DownloadJobsPDF'
		@row-clicked='viewJob'
	)
</template>

<script>
import AssetTable from '@/components/AssetTable';
import PageLayout from '@/components/PageLayout';
import ButtonExpand from '@/components/ButtonExpand';
import JobSlideOut from '@/components/slide-outs/jobs';

import {
	GetJobs,
	GetJob,
	GetRequest,
	DeleteJob,
	DownloadJobsCSV,
	DownloadJobsPDF,
	SearchJobs
} from '@/lib/API';

import { GetLastUpdated } from '@/lib/db/recentlyViewed';

import Submit from '@/lib/Submit';

import { editJob } from '@/lib/generate';
import { clone } from '@/lib/utils';

import JobConfig from '@/lib/assets/jobs';

export default {
	name : 'jobs',

	data : () => ( {
		heading : {
			title       : 'Job References',
			description : 'Click any row to view job information in full'
		},

		config : {
			columns : JobConfig.columns,

			// for if you have any columns that have a dropdown
			// for it's filtering
			dropdownOptions : JobConfig.dropdownOptions,
		},

		// main slideout
		jobPageState : 'closed',
		activeJob    : null,
		jobKey       : null,

		updated : null,

		GetJobs,
		GetJob,
		DownloadJobsCSV,
		DownloadJobsPDF,
		SearchJobs
	} ),

	created() {
		const { query } = this.$route;
		const { key }   = query;

		if ( key ) {
			this.viewJob( { jobsKey : key } );
		}

		GetLastUpdated( 'jobs', ( updated ) => {
			this.updated = updated;
		} );
	},

	watch : {
		updated : {
			handler( updated ) {
				const { activeJob } = this;

				if ( !activeJob ) {
					return;
				}

				if ( activeJob.jobsKey !== updated.key ) {
					return;
				}

				// every time the asset is updated, fetch all of the information
				// again so that the user has real time updates.
				// only fetch if the updated job is the activeJob
				GetJob( this.updated.key )
					.then( ( job ) => {
						this.activeJob = clone( job );
					} );
			}
		}
	},

	computed : {

		options() {
			return [
				{
					text   : 'Create a Job',
					active : true,
					func   : () => {
						this.dispatchForm( 'job' );
					},
				},
				{
					text   : 'Create a Misc. Job',
					active : false,
					func   : () => {
						this.dispatchForm( 'miscJob' );
					}
				},
			];
		},

		customMethods() {
			return {
				downloadCSV : DownloadJobsCSV,
				downloadPDF : DownloadJobsPDF,
				getAssets   : GetJobs,
				getAsset    : GetJob,
				search      : SearchJobs,
			};
		}

	},

	methods : {
		dispatchForm( type ) {

			this.$store.dispatch( 'form', { type } )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Creating Job...',
						state   : 'loading'
					} );

					// eslint-disable-next-line no-param-reassign
					form.value.type = type === 'job' ? 'Job' : 'Misc Job';

					Submit.job( form )
						.then( form.close() )
						.then( () => stateIndicator.resolve( 'Created Successfully' ) )
						.catch( ( err ) => {
							console.error( err );
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Create Job', message : '' } );
						} );
				} );

		},

		viewJob( { jobsKey } ) {

			this.activeJob = null;
			this.jobKey    = null;

			this.jobPageState     = 'opened';
			this.jobsLoadingState = 'loading';

			const displayStateOptions = {
				message        : 'Loading job',
				successMessage : 'Job Loaded',
				failMessage    : 'Job could not be loaded.',
				state          : 'loading',
			};

			// console.log( 'Im here...' );

			this.$store.dispatch( 'loadWithDisplayState', {
				options : displayStateOptions,
				method  : () => GetJob( jobsKey ),
			} )
				.then( ( apiJob ) => {
					// console.log( this.activeJob );
					this.activeJob = apiJob;
					this.jobKey    = apiJob.jobsKey;
					// console.log( this.activeJob );
					return apiJob.actionRequests;
				} )
				.then( ( actionRequests ) => {
					if ( actionRequests.length > 0 ) {
						this.activeJob.actionRequests.forEach( async ( ear, i ) => {
							await GetRequest( ear.actionRequestsKey )
								.then( ( apiEar ) => {
									// console.log( apiEar );
									this.activeJob.actionRequests[i].file = apiEar.file[0].name;
									this.activeJob.actionRequests[i].folder = apiEar.folder[0].folderUri;
									// console.log( this.activeJob );
								} );
						} );
					}
				} );
		},

		closeJob() {
			this.jobPageState = 'closed';
			this.activeJob    = null;
		},

		editJob() {
			const { jobsKey, type, location } = this.activeJob;

			if ( location ) this.activeJob.locationDescription = location.description;
			else this.activeJob.locationDescription = ' ';

			if ( this.activeJob.location ) delete this.activeJob.location;

			const startingData = editJob( this.activeJob );

			this.$store.dispatch( 'form', {
				type : type === 'Misc Job' ? 'miscJob' : 'job',
				args : [{ edit : true }],
				startingData,
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Editing Job...',
						state   : 'loading'
					} );

					Submit.editJob( form, type, jobsKey )
						.then( form.close() )
						.then( () => stateIndicator.resolve( 'Edited Successfully' ) )
						.catch( () => {
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Edit Job', message : '' } );
						} );
				} )
				.catch( ( e ) => {
					throw new Error( e );
				} );
		},

		async deleteJob() {

			const stateIndicator = await this.$store.dispatch( 'displayState', {
				message : 'Deleting Job...',
				state   : 'loading'
			} );

			DeleteJob( this.activeJob.jobsKey )
				.then( () => stateIndicator.resolve( 'Deleted Successfully' ) )
				.then( this.jobPageState = 'closed' )
				.catch( ( err ) => {

					console.error( err );

					stateIndicator.fail( { header : 'Didn\'t Delete Job', message : '' } );

				} );

		},
	},

	components : {
		AssetTable,
		PageLayout,
		ButtonExpand,
		JobSlideOut
	}

};
</script>

<style lang="scss">
.space-form.jobs-form {
	@include set-form-color( #80BAAC );

	.drop-box-wrapper .background {
		background: lighten( #80BAAC, 30% );
	}
}
</style>
